import { render } from "./TheCarousel.vue?vue&type=template&id=711fbbea&scoped=true"
import script from "./TheCarousel.vue?vue&type=script&lang=js"
export * from "./TheCarousel.vue?vue&type=script&lang=js"

import "./TheCarousel.vue?vue&type=style&index=0&id=711fbbea&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711fbbea"]])

export default __exports__